<template>
  <v-layout justify-center>
    <div>
      <v-layout>
        <v-flex xm12 md4 offset-md4 class="text-sm-center">
          <span class="headline">MAPS</span><br />
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12>
            <v-select
              :items="layers"
              v-model="layer"
              label="Layer"
              outline
              @change="searchYear"
            ></v-select>
          </v-flex>

          <div class="flex xs12 align-content-center text-xs-center">
            <canvas id="myCanvas" :width=canvasWidth :height=canvasHeight :style="background" @mousemove="mouseOver" @click="showCoordinates"/>
          </div>
        </v-layout>
      </v-flex>

      <InternalForm
        :visible="showEvalForm"
        :item="evalItem"
        :key="evalItem.id"
        :memberList="memberList"
        :currentYear="currentYear"
        persistent
        @close="closeThisEval"
      />

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </div>

    <v-dialog
      v-model="dialog"
      max-width="190"
      hide-overlay
    >
      <v-card>
        <v-card-text>
          {{ boothName }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import InternalForm from './InternalForm.vue'

export default {
  props: ['visible', 'currentYear'],

  components: {
    InternalForm
  },

  data () {
    return {
      myId: this.$store.state.user.id,
      page: 'maps',
      boothName: '',
      dialog: false,
      location: 'Vendor Alley',
      layers: ['Plain', 'Concert', 'Accounting'],
      layer: 'Accounting',
      isAdmin: this.$store.state.isAdmin,
      isCommChair: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      height: 0,
      rows: [],
      vendorRows: [],
      evalItem: {},
      showEvalForm: false,
      memberList: [],
      canvas: null,
      x: 0,
      y: 0,
      background: '',
      canvasWidth: 0,
      canvasHeight: 0
    }
  },

  created () {
    this.isTableLoading = true

    if (this.$route.params.currentYear) {
      this.currentYear = this.$route.params.currentYear
    } else {
      this.currentYear = this.$store.state.currentYear
    }

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getVendors()
    this.getMembers()

    this.loading = false
    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
    let c = document.getElementById('myCanvas')
    let ctx = c.getContext('2d')
    this.vueCanvas = ctx
    this.background = 'background: url("' + process.env.API_URL + '/vendor/locations/map1.png")'
    this.canvasWidth = 1224
    this.canvasHeight = 792

    this.getBooths()
    // this.loadBooths()
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  watch: {
    currentYear: {
      handler: function (val, oldVal) {
        this.getBooths()
      },
      deep: true
    }
  },

  methods: {
    showCoordinates (e) {
      let x = e.offsetX
      let y = e.offsetY

      for (let i in this.rows) {
        if (this.rows[i].status !== 'Open') {
          if (x > this.rows[i].coor1 && x < this.rows[i].coor1 + this.rows[i].coor3 &&
            y > this.rows[i].coor2 && y < this.rows[i].coor2 + this.rows[i].coor4) {
            this.evalItem = this.vendorRows.find(obj => {
              return obj.id === this.rows[i].VendorCompanyId
            })

            // console.log(this.rows[i].VendorCompanyId, this.evalItem)
            this.showEvalForm = true
          }
        }
      }
    },

    mouseOver (e) {
      let x = e.offsetX
      let y = e.offsetY

      this.boothName = ''
      this.dialog = false
      for (let i in this.rows) {
        if (this.rows[i].status !== 'Open') {
          if (x > this.rows[i].coor1 && x < this.rows[i].coor1 + this.rows[i].coor3 &&
            y > this.rows[i].coor2 && y < this.rows[i].coor2 + this.rows[i].coor4) {
            this.evalItem = this.vendorRows.find(obj => {
              return obj.id === this.rows[i].VendorCompanyId
            })

            // console.log(this.rows[i].VendorCompanyId, this.evalItem)
            this.boothName = this.evalItem.name
            this.dialog = true
          }
        }
      }
      // this.dialog = false
    },

    handleResize () {
      const height = window.innerHeight - 300
      this.height = height + 'px'
    },

    async getBooths () {
      try {
        this.vueCanvas.lineWidth = 1
        this.vueCanvas.strokeStyle = 'black'

        const response = await Api().get('vendor_location/' + this.currentYear + '/' + this.location)

        const booths = response.data

        for (let i in booths) {
          let color = 'white'
          let abbrev = ''
          booths[i].abbrev = abbrev

          if (this.layer === 'Accounting') {
            color = 'Silver'

            if (booths[i].VendorCompanyId > 0) {
              let vendor = booths[i].VendorCompany
              abbrev = vendor.abbrev
              color = 'IndianRed'

              let amount = 0
              let grandTotal = 0

              for (let j in booths[i].VendorCompany.VendorAccountings) {
                if (booths[i].VendorCompany.VendorAccountings[j].year === this.currentYear) {
                  if (booths[i].VendorCompany.VendorAccountings[j].status === 'Void') {
                    amount = 0
                  } else {
                    if (booths[i].VendorCompany.VendorAccountings[j].VendorAccountingDetails.length > 0) {
                      amount = 0
                      for (let k in booths[i].VendorCompany.VendorAccountings[j].VendorAccountingDetails) {
                        amount = amount + booths[i].VendorCompany.VendorAccountings[j].VendorAccountingDetails[k].quantity * booths[i].VendorCompany.VendorAccountings[j].VendorAccountingDetails[k].price
                      }
                    } else {
                      amount = Number(booths[i].VendorCompany.VendorAccountings[j].amount) * -1
                    }
                  }

                  grandTotal = grandTotal + amount
                  amount = 0
                }
              }

              if (grandTotal === 0) {
                color = 'SeaGreen'
              } else if (grandTotal < 0) {
                color = 'Khaki'
              } else {
                color = 'IndianRed'
              }

              grandTotal = 0
            }
          }

          if (this.layer === 'Concert') {
            color = 'Silver'

            if (booths[i].VendorCompany) {
              console.log(booths[i].VendorCompany.VendorDetails[0].concert)
              if (booths[i].VendorCompany.VendorDetails[0].concert === 'Rodeo Only') {
                color = 'IndianRed'
              } else if (booths[i].VendorCompany.VendorDetails[0].concert === 'Concert Only') {
                color = 'SeaGreen'
              } else if (booths[i].VendorCompany.VendorDetails[0].concert === 'Both Rodeo and Concert') {
                color = 'Khaki'
              }
            }
          }

          if (booths[i].type === 'poly') {
            if (booths[i].combine === 'No') {
              let poly = booths[i].poly.replace(/\s/g, '').split(',')
              this.vueCanvas.fillStyle = color

              this.vueCanvas.beginPath()
              this.vueCanvas.moveTo(poly[0], poly[1])

              for (let item = 2; item < poly.length - 1; item += 2) {
                this.vueCanvas.lineTo(poly[item], poly[item + 1])
                this.vueCanvas.stroke()
              }

              this.vueCanvas.closePath()
              this.vueCanvas.fill()
              this.vueCanvas.stroke()

              this.vueCanvas.font = '11px Arial'
              this.vueCanvas.textAlign = 'center'
              this.vueCanvas.textBaseline = 'middle'
              this.vueCanvas.fillStyle = 'blue'

              this.vueCanvas.fillText(booths[i].boothNumber, booths[i].coor1 + (booths[i].coor3 / 2 + 2), booths[i].coor2 + (booths[i].coor4 / 2 - 5))
              // this.vueCanvas.fillText(abbrev, booths[i].coor1 + (booths[i].coor3 / 2), booths[i].coor2 + (booths[i].coor4 / 2 - 24))
            }
          } else {
            if (booths[i].combine === 'No') {
              this.vueCanvas.beginPath()
              this.vueCanvas.rect(booths[i].coor1, booths[i].coor2, booths[i].coor3, booths[i].coor4)
              this.vueCanvas.fillStyle = color
              this.vueCanvas.fill()
              this.vueCanvas.stroke()

              this.vueCanvas.font = '11px Arial'
              this.vueCanvas.textAlign = 'center'
              this.vueCanvas.textBaseline = 'middle'
              this.vueCanvas.fillStyle = 'blue'

              this.vueCanvas.fillText(booths[i].boothNumber, booths[i].coor1 + (booths[i].coor3 / 2), booths[i].coor2 + (booths[i].coor4 / 2))
              // this.vueCanvas.fillText(abbrev, booths[i].coor1 + (booths[i].coor3 / 2), booths[i].coor2 + (booths[i].coor4 / 2 - 17))
            }
          }
        }

        // console.log(this.currentYear, booths)

        this.rows = response.data

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getVendors () {
      try {
        const response = await Api().get('vendors/' + this.currentYear)

        const vendorList = response.data
        console.log(vendorList)

        for (let i in vendorList) {
          let rep = ''
          if (vendorList[i].VendorDetails[0].User) {
            let user = vendorList[i].VendorDetails[0].User
            rep = user.fullName
          }

          let booths = ''

          for (let j in vendorList[i].VendorBooths) {
            booths = booths + vendorList[i].VendorBooths[j].boothNumber + ' '
          }

          vendorList[i].rep = rep
          vendorList[i].booths = booths
        }

        this.vendorRows = vendorList

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getMembers () {
      try {
        let item = {}
        let control = {}

        const controls = this.$store.state.controls
        control = controls.find(item => item === 'Vendor')
        console.log('control', control)

        console.log('controls', controls)

        if (control) {
          this.isCommChair = true
        } else {
          const response = await Api().get('get_committee_by_code/VEN/' + this.currentYear)
          this.memberList = response.data.committee.Users
          console.log(this.memberList)

          item = this.memberList.find(item => item.id === this.myId)

          if (item.UserCommittee.title === 'Chair' || item.UserCommittee.title === 'Assist Chair') {
            console.log('yes')
            this.isCommChair = true
          }

          console.log('item', this.isCommChair)
        }
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    searchYear () {
      this.getBooths()
    },

    closeThisEval (item) {
      // const evalmem = item
      // let index = this.rows.findIndex(row => row.id === evalmem.UserId)
      // this.rows[index].eval = evalmem
      this.evalItem = {}
      this.showEvalForm = false
    },

    close () {
      this.showEvalForm = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#myCanvas {
  border: 1px solid grey;
}
</style>



// WEBPACK FOOTER //
// src/components/vendor/Maps.vue